import { render, staticRenderFns } from "./busFormComp.vue?vue&type=template&id=b47d2296&scoped=true&"
import script from "./busFormComp.vue?vue&type=script&lang=js&"
export * from "./busFormComp.vue?vue&type=script&lang=js&"
import style0 from "./busFormComp.vue?vue&type=style&index=0&id=b47d2296&scoped=true&lang=css&"
import style1 from "./busFormComp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47d2296",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCheckbox,VCol,VDivider,VRow})
